<template>
	<!-- this.numberOfPersons.amountAdults + ' Vuxna ' + this.numberOfPersons.amountYouths + ' Ungdomar ' + this.numberOfPersons.amountChildren + ' Knattar ' + this.numberOfPersons.amountSeniors + ' Seniorer ' -->
	<section id="planer" class="accommodation-search">
		
		<div id="accommodation-search">
			<PageLoading v-if="pageLoading" />
			<div v-if="!pageLoading" class="search">
				<!-- Filter -->
				<div class="grid-container">
					<div class="grid-x grid-margin-x">
						<div class="cell small-12 medium-6 large-6">
							<h1>{{ $t('accommodation.heading') }}</h1>
						</div>
						<div class="cell small-12 medium-6 large-6">
							<div class="search-tabs">
								<Tab
									:button="true"
									:active="activeFilterTab === 1"
									@click.native="activeFilterTab = 1"
								>
									{{ $t('search.tabFilterLabel') }}
								</Tab>
								<Tab
									:button="true"
									:active="activeFilterTab === 2"
									@click.native="activeFilterTab = 2"
								>
									{{ $t('search.tabSearchLabel') }}
								</Tab>
							</div>

							<form
								class="search-housenumber"
								@submit.prevent="getAccomodationWithHouseNumber"
							>
								<InputComponent
									:placeholderValue="$t('search.placeholderSearchHousenumber')"
									v-model="houseNumber"
									:lightTheme="true"
									class="search-housenumber__input"
								/>
								<Button
									class="search-housenumber__btn"
									:size="'small'"
									:loading="loadingHouseNumber"
									@click.native="getAccomodationWithHouseNumber"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'btn--reset'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M16.62 15.13A6.9 6.9 0 0018 11a7 7 0 10-2.77 5.56l4.35 4.35L21 19.5zM11 16a5 5 0 115-5 5 5 0 01-5 5z"/></svg>
								</Button>
							</form>
						</div>
					</div>
					<div v-if="activeFilterTab === 2" class="grid-x">
						<form
							class="search-housenumber-mobile"
							@submit.prevent="getAccomodationWithHouseNumber"
						>
							<InputComponent
								:placeholderValue="$t('search.placeholderSearchHousenumber')"
								v-model="houseNumber"
								:lightTheme="true"
								class="search-housenumber__input"
							/>
							<Button
								class="search-housenumber__btn"
								:size="'small'"
								:loading="loadingHouseNumber"
								@click.native="getAccomodationWithHouseNumber"
							>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'btn--reset'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M16.62 15.13A6.9 6.9 0 0018 11a7 7 0 10-2.77 5.56l4.35 4.35L21 19.5zM11 16a5 5 0 115-5 5 5 0 01-5 5z"/></svg>
							</Button>
						</form>
					</div>
					<div
						v-if="activeFilterTab === 1"
						class="grid-x filters"
						:class="fadeFilters ? 'filters--fade' : ''"
					>
						<div class="cell small-12 medium-12 large-6 booking-dates">
							<Accordion
								v-on:toggle="
									() => {
										this.date.show = !this.date.show
									}
								"
								:title="accordionLabelDate()"
								:subTitle="$t('search.dateAccordionSubtitle')"
								v-bind:show="this.date.show"
								iconType="calendar"
								:errorMessage="date.message"
							>
								<DatePicker
									:selectForward="false"
									:format="'YYYY-MM-DD'"
									:allowedDates="this.allowedStartDates"
									:minNight="minNight"
									:maxNight="maxNight"
									:maxDate="this.getMaxDate"
									:startDate="this.startDate"
									:endDate="this.endDate"
									:monthList="$t('datepicker.monthList')"
									:placeholder="$t('datepicker.selectDateRange')"
									:startdateHelptext="$t('datepicker.selectArrivalDate')"
									:enddateHelptext="$t('datepicker.selectDepartureDate')"
									:accordionTheme="true"
									@update="updateDate"
									@reset="resetDatepicker"
								/>
								<div class="datepicker-alert">
									<AlertMessage
										:show="this.calendarAlertText != ''"
										:blue="true"
										:fat="true"
									>
										{{ calendarAlertText }}
									</AlertMessage>
								</div>
							</Accordion>
						</div>
						<div class="cell small-12 medium-12 large-6">
							<Accordion
								v-on:toggle="
									() => {
										this.numberOfPersons.show = !this.numberOfPersons.show
									}
								"
								:title="accordionLabelPersons()"
								:subTitle="$t('search.peopleAccordionSubtitle')"
								v-bind:show="this.numberOfPersons.show"
								iconType="people"
							>
								<div class="input-collection">
									<div class="grid-x">
										<div class="cell small-6 medium-4">
											<p class="h4">{{ $t('search.numberLabelChildren') }}</p>
											<p class="small small--color-lynch">
												{{ $t('search.numberLabelChildrenYears') }}
											</p>
										</div>
										<div class="cell small-6 medium-8">
											<NumberComponent
												:initalValue="this.numberOfPersons.amountChildren"
												@number-input="
													val => {
														this.numberOfPersons.amountChildren = val
													}
												"
											/>
										</div>
										<div class="cell small-6 medium-4">
											<p class="h4">{{ $t('search.numberLabelYouth') }}</p>
											<p class="small small--color-lynch">
												{{ $t('search.numberLabelYouthYears') }}
											</p>
										</div>
										<div class="cell small-6 medium-8">
											<NumberComponent
												:initalValue="this.numberOfPersons.amountYouths"
												@number-input="
													val => {
														this.numberOfPersons.amountYouths = val
													}
												"
											/>
										</div>
										<div class="cell small-6 medium-4">
											<p class="h4">{{ $t('search.numberLabelAdult') }}</p>
											<p class="small small--color-lynch">
												{{ $t('search.numberLabelAdultYears') }}
											</p>
										</div>
										<div class="cell small-6 medium-8">
											<NumberComponent
												:initalValue="this.numberOfPersons.amountAdults"
												:minNumber="1"
												@number-input="
													val => {
														this.numberOfPersons.amountAdults = val
													}
												"
											/>
										</div>
									</div>
								</div>
							</Accordion>
						</div>
						<div class="cell small-12 medium-12 large-6">
							<Accordion
								v-on:toggle="
									() => {
										this.area.show = !this.area.show
									}
								"
								:title="accordionLabelAreas()"
								:subTitle="$t('search.areaAccordionSubtitle')"
								v-bind:show="this.area.show"
								iconType="location"
							>
								<div class="checkbox-list">
									<div
										v-for="cabinArea in this.apiFilters.cabinAreas"
										:key="cabinArea.id"
									>
										<label class="checkbox">
											<input
												class="checkbox__input"
												type="checkbox"
												v-bind:value="cabinArea.title"
												v-model="area.chosenAreas"
											/>
											<span class="checkbox__box">
												<span>
													<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
												</span>
											</span>
											<span class="checkbox__title">
												{{ toLowerCase(cabinArea.title) }}
											</span>
										</label>
									</div>
								</div>
							</Accordion>
						</div>
						<div class="cell small-12 medium-12 large-6">
							<Accordion
								v-on:toggle="
									() => {
										this.characteristics.show = !this.characteristics.show
									}
								"
								:title="accordionLabelCharacteristics()"
								:subTitle="$t('search.characteristicsAccordionSubtitle')"
								v-bind:show="this.characteristics.show"
								iconType="facilities"
							>
								<div class="checkbox-list">
									<div
										v-for="facility in this.apiFilters.facilities"
										:key="facility.id"
									>
										<label class="checkbox">
											<input
												class="checkbox__input"
												type="checkbox"
												v-bind:value="facility.name"
												v-model="characteristics.chosenCharacteristics"
											/>
											<span class="checkbox__box">
												<span>
													<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
												</span>
											</span>
											<span class="checkbox__title">{{ facility.name }}</span>
										</label>
									</div>
								</div>
							</Accordion>
						</div>
						<!-- <div class="cell small-12 medium-12 large-6">
							<Accordion
								v-on:toggle="() => {this.search.show = !this.search.show}"
								:title="$t('search.searchAccordionLabel')"
								:subTitle="$t('search.searchAccordionSubtitle')"
								v-bind:show="this.search.show"
								iconType="search"
							>
								<InputComponent
									:placeholderValue="$t('search.placeholderSearchHousenumber')"
									v-model="houseNumber"
									:lightTheme="true"
								/>
							</Accordion>
						</div> -->
						<!-- Fält med Kampanjkod  -->
						<div class="cell small-12 medium-12 large-6">
							<Accordion
								v-on:toggle="
									() => {
										this.campaignCode.show = !this.campaignCode.show
									}
								"
								:title="$t('search.campaignAccordionLabel')"
								:subTitle="$t('search.campaignAccordionSubtitle')"
								v-bind:show="this.campaignCode.show"
								iconType="campaigncode"
								:fixedOpen="true"
							>
								<InputComponent
									v-model="campaignCode.value"
									:placeholderValue="$t('search.placeholderAddCampaigncode')"
									:hasError="campaignCode.error"
									:errorMessage="campaignCode.message"
									:lightTheme="true"
									:accepted="campaignCode.accepted"
								/>
							</Accordion>
						</div>
						<div class="cell small-12 medium-offset-4 medium-4 search-submit">
							<!--<Button
								v-if="detectMandatoryFilters === false"
								:full="true"
								:disabled="true"
								@click.native="requestAccommodations"
								>{{ $t('search.searchButtonText') }}</Button
							>-->
							<Button
								:full="true"
								:loading="loading"
								@click.native="confiremSearch"
							>
								{{ $t('search.searchButtonText') }}
							</Button>
						</div>
						<!-- <WeatherBar :sticky="true" /> -->
					</div>
				</div>

				<!-- Number of results -->
				<div class="accommodation-results__sort" v-if="!pageLoading">
					<div class="load-overlay" v-if="loading || loadingHouseNumber"></div>
					<div class="grid-container grid-x">
						<div
							class="accommodation-results__sort-title cell small-12 medium-6"
						>
							<span>
								{{ $t('search.found') }}
								<strong>{{ allAccommodations.length }}</strong>
								{{ $t('search.accommodations') }}
							</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Result -->
			<div
				v-if="!pageLoading"
				ref="results"
				class="accommodation-results"
				:class="{ 'accommodation-results--loading': loading }"
			>
				<!-- Loading overlay -->
				<div class="load-overlay" v-if="loading || loadingHouseNumber">
					<PageLoading v-if="loadingStart" />
					<div v-else class="accommodation-results__updating">
						<Loading :dark="true" :large="true" />
						<span class="accommodation-results__updating-heading">
							{{ $t('search.updatingResultHeading') }}
						</span>
						<span class="accommodation-results__updating-text">
							{{ $t('search.updatingResultText') }}
						</span>
					</div>
				</div>

				<!-- Tabs & sorting/filter -->
				<div class="grid-container">
					<div class="grid-x">
						<!-- Tab links (area view, accommodation view, map view) -->
						<div class="accommodation-results__tabs cell small-12 large-6">
							<Tab
								:button="false"
								:active="activeTab === 4"
								@click.native="activeTab = 4"
							>
								{{ $t('search.areaView') }}
							</Tab>
							<Tab
								:button="false"
								:active="activeTab === 1 || activeTab === 2 || activeTab === 3"
								@click.native="activeTab = 2"
							>
								{{ $t('search.accommodationView') }}
							</Tab>
							<!-- <Tab
								:button="false"
								:active="activeTab === 3"
								@click.native="activeTab = 3"
							>
								{{ $t('search.cartView') }}
							</Tab> -->
						</div>

						<!-- Sorting (for list/grid view only) -->
						<div
							v-if="activeTab === 1 || activeTab === 2 || activeTab === 3"
							class="accommodation-results__sort-buttons cell small-12 large-6"
						>
							<div
								class="accommodation-results__sort-select"
								v-if="activeTab === 1 || activeTab === 2"
							>
								<Select
									v-model="currentSortIndex"
									:defaultSelectedValue="selectedSortIndex"
									:placeholder="$t('search.choose')"
									:option-items="getSortArray()"
									:filterTheme="true"
								></Select>
							</div>

							<!-- Desktop -->
							<div class="accommodation-results__sort-desktop">
								<Tab
									:button="true"
									:active="activeTab === 1"
									@click.native="activeTab = 1"
								>
									<FilterViewButton>
										<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'btn--reset'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M2 4h2v2H2zM2 18h2v2H2zM2 11h2v2H2zM6 4h16v2H6zM6 18h16v2H6zM6 11h16v2H6z"/></svg>
									</FilterViewButton>
								</Tab>
								<Tab
									:button="true"
									:active="activeTab === 2"
									@click.native="activeTab = 2"
								>
									<FilterViewButton>
										<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'btn--reset'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M3 21h8v-8H3zm2-6h4v4H5zM13 3v8h8V3zm6 6h-4V5h4zM13 21h8v-8h-8zm2-6h4v4h-4zM3 11h8V3H3zm2-6h4v4H5z"/></svg>
									</FilterViewButton>
								</Tab>
								<Tab
									:button="true"
									:active="activeTab === 3"
									@click.native="activeTab = 3"
								>
									<FilterViewButton>
										<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'btn--reset'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11.5 6.32a2.88 2.88 0 102.88 2.88 2.89 2.89 0 00-2.88-2.88zm0 4.6a1.73 1.73 0 111.73-1.72 1.73 1.73 0 01-1.73 1.72z"/><path d="M11.5 1.15A7.49 7.49 0 004 8.62c0 3.9 2.76 9.2 6.71 12.89l.79.73.79-.73c3.95-3.69 6.71-9 6.71-12.89a7.49 7.49 0 00-7.5-7.47zm0 17.9c-3.41-3.53-5.19-7.82-5.19-10.43a5.19 5.19 0 0110.38 0c0 2.61-1.78 6.9-5.19 10.43z"/></svg>
									</FilterViewButton>
								</Tab>
							</div>
						</div>
					</div>
				</div>

				<div class="grid-container">
					<!-- List view -->
					<div
						class="accommodation-results__tab-list grid-x"
						v-if="activeTab === 1"
					>
						<AccommodationList
							v-for="item in sortedAccommodationList"
							:key="item.id"
							:id="item.id"
							:type="item.type"
							:poollid="item.poollid"
							:unitlid="item.unitlid"
							:image="item.images"
							:title="item.title"
							:price="item.price"
							:pricecode="item.pricecode"
							:fullPrice="item.ordinaryprice"
							:description="item.description"
							:beds="item.sleepingArrangementBeds"
							:bedrooms="item.sleepingArrangementRooms"
							:extraBeds="item.numberOfExtraBeds"
							:loft="item.loft"
							:area="item.sleepingArrangementArea"
							:distanceToLift="item.utilities.lift"
							:addons="item.addons"
							:plusaccommodation="item.plusaccommodation"
							:departurecleaning="item.departurecleaning"
							:breakfastincluded="item.breakfastincluded"
							:linensetincluded="item.linensetincluded"
							:totalPeople="totalPeople()"
						/>
						<div class="grid-x full-width">
							<div
								v-if="accommodations.length < allAccommodations.length"
								class="cell small-12 medium-offset-4 medium-4 accommodation-results__show-more"
							>
								<Button color="dark" :full="true" @click.native="showMore">
									Visa fler
								</Button>
								<span>
									Visar {{ accommodations.length }} {{ $t('search.of') }}
									{{ allAccommodations.length }}
								</span>
							</div>
						</div>
					</div>

					<!-- Grid view -->
					<div
						class="accommodation-results__tab-grid grid-x"
						v-if="activeTab === 2"
					>
						<AccommodationCard
							v-for="item in sortedAccommodationList"
							:type="item.type"
							:key="item.id"
							:id="item.id"
							:poollid="item.poollid"
							:unitlid="item.unitlid"
							:image="item.images"
							:title="item.title"
							:price="item.price"
							:pricecode="item.pricecode"
							:fullPrice="item.ordinaryprice"
							:description="item.description"
							:beds="item.sleepingArrangementBeds"
							:bedrooms="item.sleepingArrangementRooms"
							:extraBeds="item.numberOfExtraBeds"
							:loft="item.loft"
							:area="item.sleepingArrangementArea"
							:distanceToLift="item.utilities.lift"
							:hasHoverEffect="true"
							:addons="item.addons"
							:plusaccommodation="item.plusaccommodation"
							:departurecleaning="item.departurecleaning"
							:breakfastincluded="item.breakfastincluded"
							:linensetincluded="item.linensetincluded"
							:totalPeople="totalPeople()"
						/>
						<div class="grid-x full-width">
							<div
								v-if="accommodations.length < allAccommodations.length"
								class="cell small-12 medium-offset-4 medium-4 accommodation-results__show-more"
							>
								<Button
									color="dark"
									:full="true"
									:loading="loading"
									@click.native="showMore"
								>
									{{ $t('search.showMore') }}
								</Button>
								<span>
									{{ $t('search.showing') }} {{ accommodations.length }}
									{{ $t('search.of') }} {{ allAccommodations.length }}
								</span>
							</div>
						</div>
					</div>

					<!-- Map view -->
					<div class="accommodation-results__tab-map" v-if="activeTab === 3">
						<Googlemaps :markers="markers" :hasMultiMarkers="true" />
					</div>

					<!-- Area view -->
					<div class="accommodation-results__tab-map" v-if="activeTab === 4">
						<template v-for="cabinArea in getAreasList()">
							<AccommodationArea
								v-if="showAccommodationListByArea(cabinArea.id).length"
								:key="cabinArea.id"
								:id="cabinArea.id"
								:image="cabinArea.images"
								:title="cabinArea.title"
								:description="cabinArea.description"
								:facilities="cabinArea.facilities"
								:amountOfResults="
									showAccommodationListByArea(cabinArea.id).length
								"
							>
								<div class="grid-x accommodation-results__byarea">
									<AccommodationCard
										v-for="item in showAccommodationListByArea(cabinArea.id)"
										:type="item.type"
										:key="item.id"
										:id="item.id"
										:poollid="item.poollid"
										:unitlid="item.unitlid"
										:image="item.images"
										:title="item.title"
										:price="item.price"
										:fullPrice="item.ordinaryprice"
										:description="item.description"
										:beds="item.sleepingArrangementBeds"
										:bedrooms="item.sleepingArrangementRooms"
										:extraBeds="item.numberOfExtraBeds"
										:loft="item.loft"
										:area="item.sleepingArrangementArea"
										:distanceToLift="item.utilities.lift"
										:hasHoverEffect="true"
										:addons="item.addons"
										:plusaccommodation="item.plusaccommodation"
										:departurecleaning="item.departurecleaning"
										:breakfastincluded="item.breakfastincluded"
										:linensetincluded="item.linensetincluded"
										:totalPeople="totalPeople()"
									/>
								</div>
							</AccommodationArea>
						</template>
					</div>

					<!-- No results -->
					<div v-if="showNoResults">
						<div class="grid-x cell small-12">
							<div class="accommodation-results__no-results">
								<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
								<p>{{ $t('emptyStates.noResultsAccommodationText') }}</p>
								<Button @click.native="scrollAndFocus()" size="small">
									{{ $t('emptyStates.noResultsButtonText') }}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Empty state -->
		<EmptyState
			:type="'accommodation'"
			:heading="accommodationHeading"
			:preamble="accommodationPreamble"
			:bodytext="accommodationBodytext"
			:linktext="$t('emptyStates.accommodationLinktext')"
		>
			<template v-slot:rightBoxes>
				<div class="grid-x grid-margin-x">
					<div
						class="cell small-12 medium-6 large-7 large-offset-5"
						v-if="!isLoggedIn()"
					>
						<InfoBox
							:heading="accountHeading"
							:bodytext="accountBodytext"
							cta="newaccount"
							textLink="login"
							theme="light"
							level="secondary"
						/>
					</div>
					<div class="cell small-12 medium-6 large-12">
						<InfoBox
							:heading="campingHeading"
							:bodytext="campingBodytext"
							theme="light"
							level="primary"
							:lastChild="true"
						/>
					</div>
				</div>
			</template>
			<!-- <template v-slot:rightBoxes>
				<div class="grid-x grid-margin-x">
					<div
						class="cell small-12 medium-6 large-7 large-offset-5"
						v-if="!isLoggedIn()"
					>
						<InfoBox
							:heading="$t('emptyStates.profileHeading')"
							:bodytext="$t('emptyStates.profileBodytext')"
							cta="newaccount"
							textLink="login"
							theme="light"
							level="secondary"
						/>
					</div>
					<div class="cell small-12 medium-6 large-12">
						<InfoBox
							:heading="$t('emptyStates.campingHeading')"
							:bodytext="$t('emptyStates.campingBodytext')"
							theme="light"
							level="primary"
							:lastChild="true"
						/>
					</div>
				</div>
			</template> -->
		</EmptyState>

		<Modal v-if="showModal === true" @close="showModal = false">
			<h4>{{ $t('search.errorModalTitle') }}</h4>
			<br />
			<p>{{ $t('search.errorModalBody') }}</p>
		</Modal>
	</section>
</template>

<script>
import store from '../vueX/store'
//import moment from "moment";
import Accordion from '../components/molecules/Accordion.vue'
import DatePicker from '../components/molecules/DatePicker'
import NumberComponent from '../components/atoms/NumberComponent'
import InputComponent from '../components/atoms/InputComponent'
import AlertMessage from '../components/atoms/AlertMessage'
import Button from '../components/atoms/Button'
import AccommodationCard from '../components/molecules/AccommodationCard.vue'
import FilterViewButton from '../components/atoms/FilterViewButton'
import Select from '../components/atoms/Select'
import Tab from '../components/atoms/Tab'
import AccommodationList from '../components/molecules/AccommodationList.vue'
import Googlemaps from '../components/molecules/GoogleMaps.vue'
import Modal from '../components/molecules/Modal'
import PageLoading from '../components/atoms/PageLoading'
import Loading from '../components/atoms/Loading'
import EmptyState from '../components/molecules/EmptyState'
import InfoBox from '../components/molecules/InfoBox'
import AccommodationArea from '../components/molecules/AccommodationArea'

export default {
	name: 'AccomodationSearch',
	store,
	components: {
		Accordion,
		DatePicker,
		NumberComponent,
		InputComponent,
		AlertMessage,
		Button,
		AccommodationCard,
		FilterViewButton,
		Select,
		Tab,
		AccommodationList,
		Googlemaps,
		Modal,
		PageLoading,
		Loading,
		EmptyState,
		InfoBox,
		AccommodationArea
	},
	data() {
		return {
			//Datepicker
			date: {
				show: false,
				chosenDate: null,
				accordionLabel: '',
				errorMessage: ''
			},
			selectedStartDate: '',
			selectedEndDate: '',
			minNight: 0,
			maxNight: 0,
			getMaxDate: '',
			allowedStartDates: [],
			startDate: '',
			endDate: '',
			//Selected people
			numberOfPersons: {
				show: false,
				amountAdults: 2,
				amountChildren: 0,
				amountYouths: 0,
				amountSeniors: 0,
				totalNumber: 0,
				accordionLabel: ''
			},
			area: {
				show: false,
				cabinAreas: null,
				chosenAreas: [],
				accordionLabel: ''
			},
			characteristics: {
				show: false,
				facilities: null,
				chosenCharacteristics: [],
				accordionLabel: ''
			},
			houseNumber: '',
			campaignCode: {
				value: '',
				message: '',
				show: false,
				error: false,
				accepted: false
			},
			search: {
				show: false
			},
			loading: false,
			loadingHouseNumber: false,
			loadingStart: false,
			pageLoading: false,
			fadeFilters: false,
			/*startDate: moment("2020-04-19").toDate(),
      endDate: moment("2020-04-23").toDate(),*/
			allAccommodations: [],
			accommodations: [],
			currentNumberOfAcc: 12,
			activeTab: 4,
			activeFilterTab: 1,
			//Data för sortering
			currentSortIndex: '0',
			selectedSortIndex: 'Select a option',
			sortArray: [
				{ id: '0', text: this.$t('search.filterOptionUnsorted') },
				{ id: '1', text: this.$t('search.filterOptionSortByPrice') },
				{ id: '2', text: this.$t('search.filterOptionSortByDistance') },
				{ id: '3', text: this.$t('search.filterOptionSortByName') }
			],
			//Markörer för kartan
			markers: [],
			showModal: false,
			showNoResults: false,
			accommodationHeading: '',
			accommodationBodytext: '',
			accommodationPreamble: '',
			campingHeading: '',
			campingBodytext: '',
			accountHeading: '',
			accountBodytext: '',
			calendarAlertText: '',
			areasRandomListOrder: []
		}
	},

	methods: {
		isLoggedIn() {
			return store.state.user != null
		},
		toLowerCase(string) {
			return string.toLowerCase().trim()
		},
		getSortArray() {
			return this.sortArray.filter(each => {
				return this.accommodations.length &&
					each.id == 1 &&
					this.accommodations[0].price == 0
					? false
					: true
			})
		},
		getAreasList() {
			const areaList = [...this.apiFilters.cabinAreas]
			const areasRandomListOrder =
				store.state.accommodation.areasRandomListOrder

			//No saved sort order
			if (areasRandomListOrder.length == 0) {
				//Randomize area list
				for (let i = this.apiFilters.cabinAreas.length - 1; i > 0; i--) {
					let j = Math.floor(Math.random() * (i + 1))
					let k = areaList[i]
					areaList[i] = areaList[j]
					areaList[j] = k
				}

				//Store IDs of randomized list
				const areaIdList = areaList.map(function (obj) {
					return obj.id
				})
				store.dispatch('SET_AREAS_RANDOM_LIST_ORDER', areaIdList)

				//Saved sort order
			} else {
				//Sort area list according to stored random sort order
				areaList.sort(function (a, b) {
					return (
						store.state.accommodation.areasRandomListOrder.indexOf(a['id']) -
						store.state.accommodation.areasRandomListOrder.indexOf(b['id'])
					)
				})
			}

			return areaList
		},
		addMarkersOnMap() {
			let markersArray = this.allAccommodations.filter(item => {
				if (item.utilities != null && item.location != null) {
					if (item.utilities.lift != null && item.location.lng != null) {
						return item
					}
				}
			})
			const newMarkersArray = markersArray.map(item => {
				return {
					price: item.price,
					title: item.title,
					poollid: item.poollid,
					unitlid: item.unitlid,
					distanceToLift: item.utilities.lift + 'm',
					position: { lat: item.location.lat, lng: item.location.lng }
				}
			})
			this.markers = newMarkersArray
		},
		focusHouseNumber(val) {
			this.fadeFilters = val
		},
		accordionLabelPersons() {
			const total =
				parseInt(this.numberOfPersons.amountAdults) +
				parseInt(this.numberOfPersons.amountYouths) +
				parseInt(this.numberOfPersons.amountChildren)
			if (total > 0) {
				return this.$t('search.amount') + ' ' + total
			} else {
				return this.numberOfPersons.accordionLabel
			}
		},
		accordionLabelAreas() {
			return this.area.chosenAreas.length
				? this.$t('search.amount') + ' ' + this.area.chosenAreas.length
				: this.area.accordionLabel
		},
		accordionLabelCharacteristics() {
			return this.characteristics.chosenCharacteristics.length
				? this.$t('search.amount') +
						' ' +
						this.characteristics.chosenCharacteristics.length
				: this.characteristics.accordionLabel
		},
		accordionLabelDate() {
			return this.startDate
				? this.startDate + ' ' + this.$t('search.to') + ' ' + this.endDate
				: this.date.accordionLabel
		},
		updateDate(date) {
			// När datepicker uppdateras
			this.startDate = date.start
			this.endDate = date.end

			//hämtar all tillgänliga datum för det valda datumet
			const getSelectedDate = this.apiFilters.bookableDates.filter(item => {
				if (item.date == date.start) {
					return item.date
				}
			})

			if (getSelectedDate != '') {
				//kollar om boendet har inte har ett max antal för bokningsbara dagar
				if (getSelectedDate[0].unlimitedDays == true) {
					this.allowedStartDates = []
					this.getMaxDate = getSelectedDate[0].periodEndDate
				} else {
					this.allowedStartDates = getSelectedDate[0].endDates
				}
			}
		},
		resetDatepicker() {
			this.date.accordionLabel = this.$t('search.chooseDates')

			const availableDates = this.apiFilters.bookableDates.map(
				item => item.date
			)

			// Way ? this resets all dates so no dates is pickable that should be.
			// const endDates = this.apiFilters.bookableDates
			// 	.map(item => item.endDates)
			// 	.flat()
			// 	.sort()

			// this.getMaxDate = endDates[endDates.length - 1]
			this.getMaxDate = ''
			this.maxNight = 0
			this.minNight = 0
			this.allowedStartDates = availableDates
			this.startDate = ''
			this.endDate = ''
		},
		confiremSearch() {
			this.loading = true
			this.campaignCode.message = ''
			this.campaignCode.error = false
			this.showNoResults = false
			this.houseNumber = ''
			this.date.message = ''
			this.stateToQuery()

			store.dispatch('SET_ACCOMMODATION_RANDOM_LIST_ORDER', [])
			store.dispatch('SET_AREAS_RANDOM_LIST_ORDER', [])

			// clase accordions
			// this.numberOfPersons.show = false
			// this.date.show = false
			// this.area.show = false
			// this.characteristics.show = false

			// this.$scrollTo(this.$refs.results, 500, { offset: -60 })

			if (this.campaignCode.value && !this.startDate && !this.endDate) {
				this.loading = false
				this.date.message = this.$t('search.campaignNeedDate')
				return
			}

			// if (this.campaignCode.value) {
			// 	this.getAccomodation(this.campaignCode.value)
			// }
			this.getAccomodation(false)
		},
		getAccomodation(scrollOption) {
			store
				.dispatch('GET_ACCOMMODATIONS_WITH_DATES', {
					startDate: this.startDate,
					endDate: this.endDate,
					unitlid: 0,
					poollid: 0,
					// campaignCode: campaignCode ? campaignCode : '',
					campaignCode: this.campaignCode.value,
					amountAdults: this.numberOfPersons.amountAdults,
					amountChildren: this.numberOfPersons.amountChildren,
					amountYouths: this.numberOfPersons.amountYouths
				})
				.then(success => {

					//Invalid campaign code
					if (
						success.errorCode !== undefined &&
						success.errorCode === 1 &&
						this.campaignCode.value
					) {
						this.campaignCode.message = this.$t('search.errorCampaignCode')
						this.campaignCode.error = true
						success = [] // quick and dirty
					}

					//Set the result
					this.accommodations = success
						? this.filterAccomedation(success).slice(0, 12)
						: []
					this.allAccommodations = success
						? this.filterAccomedation(success)
						: []

					// If result is empty show it to the user
					if (Array.isArray(success) && this.allAccommodations.length === 0) {
						this.showNoResults = true
						// } else if (success == false && this.campaignCode.value) {
					} else if (
						success.errorCode !== undefined &&
						success.errorCode === 0 &&
						this.campaignCode.value
					) {
						this.campaignCode.message = this.$t('search.errorCampaignCode')
						this.campaignCode.error = true
						success = [] // quick and dirty
					}

					//store.dispatch('SET_ACCOMMODATIONS_LIST', success ? success : [])

					store.dispatch('GTM_PUSH_ACCOMMODATION_SEARCH', {
						payload: this.accommodations,
						searchFilters: {
							startDate: this.startDate,
							endDate: this.endDate,
							amountAdults: this.numberOfPersons.amountAdults,
							amountChildren: this.numberOfPersons.amountChildren,
							amountYouths: this.numberOfPersons.amountYouths,
							place: this.area.chosenAreas.length
								? this.area.chosenAreas.join('|')
								: 'all',
							amenities: this.characteristics.chosenCharacteristics.length
								? this.characteristics.chosenCharacteristics.join('|')
								: 'all',
							cottageOrApartmentNumber: this.houseNumber,
							campaignCode: this.campaignCode.value,
							sortBy: this.sortArray[this.currentSortIndex].text,
							activeTab: this.activeTab
						}
					})
					this.addMarkersOnMap()

					this.loadingHouseNumber = false
					this.loading = false
					this.loadingStart = false

					// If there are only 1 area, don't show area view as default
					let allAreas = this.allAccommodations.map(a => a.parentpool)
					allAreas = [...new Set(allAreas)]
					if (allAreas.length < 2) {
						this.activeTab = 2
					} else {
						this.activeTab = 4
					}

					if (
						scrollOption &&
						(success.length !== 0 ||
						this.campaignCode.error ||
						this.showNoResults)
					) {
						this.$scrollTo(this.$refs.results, 500, { offset: -60 })
					}
				})
		},
		getAccomodationWithHouseNumber() {
			this.campaignCode.message = ''
			this.campaignCode.error = false

			if (this.houseNumber) {
				this.loadingHouseNumber = true

				this.stateToQuery()

				store
					.dispatch('GET_ACCOMMODATIONS_FROM_HOUSE_NUMBER', {
						houseNumber: String(this.houseNumber).toUpperCase()
					})
					.then(success => {
						this.accommodations = success ? success.slice(0, 12) : []
						this.allAccommodations = success ? success : []

						store.dispatch('SET_ACCOMMODATIONS_LIST', success ? success : [])
						store.dispatch('GTM_PUSH_ACCOMMODATION_SEARCH', {
							payload: this.accommodations,
							searchFilters: {
								startDate: this.startDate,
								endDate: this.endDate,
								amountAdults: this.numberOfPersons.amountAdults,
								amountChildren: this.numberOfPersons.amountChildren,
								amountYouths: this.numberOfPersons.amountYouths,
								place: this.area.chosenAreas.length
									? this.area.chosenAreas.join('|')
									: 'all',
								amenities: this.characteristics.chosenCharacteristics.length
									? this.characteristics.chosenCharacteristics.join('|')
									: 'all',
								cottageOrApartmentNumber: this.houseNumber,
								campaignCode: this.campaignCode.value,
								sortBy: this.sortArray[this.currentSortIndex].text,
								activeTab: this.activeTab
							}
						})
						this.addMarkersOnMap()

						this.loadingHouseNumber = false

						// If there are only 1 area, don't show area view as default
						let allAreas = this.allAccommodations.map(a => a.parentpool)
						allAreas = [...new Set(allAreas)]
						if (allAreas.length < 2) {
							this.activeTab = 2
						} else {
							this.activeTab = 4
						}

						// Scroll down to result
						if (
							success.length !== 0 ||
							this.campaignCode.error ||
							this.showNoResults
						) {
							this.$scrollTo(this.$refs.results, 500, { offset: -60 })
						}
						
					})
			}
		},
		filterAccomedation(list) {
			// Lägger ihop array:en av strängar till en sträng
			const joindCabinAreas = this.area.chosenAreas
			const joinedFacilities = this.characteristics.chosenCharacteristics

			//Retunerar bara boenden från områden som har blivit ifyllda
			const filteredCabinAreas = list.filter(item => {
				if (joindCabinAreas != '') {
					return joindCabinAreas.indexOf(item.districtText) !== -1
				} else {
					return item
				}
			})

			//Här kör vi på objektet som har fått stugområderna och jämför med vilka faciliteter som finns.
			//Jämför valda faciliteter med faciliteter i boende objectet
			const filtered = filteredCabinAreas.filter(item => {
				let facilites = item.facilitiesData

				if (facilites === null || facilites.length == 0) facilites = ['']

				return (
					facilites.filter(facilites => {
						return joinedFacilities.indexOf(facilites) > -1
					}).length === joinedFacilities.length
				)
			})

			return filtered
		},
		//visar fler boenden med 12 stycken per gång
		showMore() {
			//this.currentNumberOfAcc
			this.currentNumberOfAcc = this.accommodations.length
			this.currentNumberOfAcc = this.currentNumberOfAcc + 12
			this.accommodations = this.allAccommodations.slice(
				0,
				this.currentNumberOfAcc
			)
			store.dispatch('GTM_PUSH_ACCOMMODATION_SEARCH', {
				payload: [...this.accommodations.slice(12)],
				searchFilters: {
					startDate: this.startDate,
					endDate: this.endDate,
					amountAdults: this.numberOfPersons.amountAdults,
					amountChildren: this.numberOfPersons.amountChildren,
					amountYouths: this.numberOfPersons.amountYouths,
					place: this.area.chosenAreas.length
						? this.area.chosenAreas.join('|')
						: 'all',
					amenities: this.characteristics.chosenCharacteristics.length
						? this.characteristics.chosenCharacteristics.join('|')
						: 'all',
					cottageOrApartmentNumber: this.houseNumber,
					campaignCode: this.campaignCode.value,
					sortBy: this.sortArray[this.currentSortIndex].text,
					activeTab: this.activeTab
				}
			})
			this.addMarkersOnMap()
		},
		stateToQuery() {
			const queryObject = {
				s: this.startDate ? this.startDate : undefined,
				e: this.endDate ? this.endDate : undefined,
				cc: this.campaignCode.value ? this.campaignCode.value : undefined,
				a: this.numberOfPersons.amountAdults
					? this.numberOfPersons.amountAdults
					: undefined,
				c: this.numberOfPersons.amountChildren
					? this.numberOfPersons.amountChildren
					: undefined,
				y: this.numberOfPersons.amountYouths
					? this.numberOfPersons.amountYouths
					: undefined,
				filter: this.characteristics.chosenCharacteristics.length
					? this.characteristics.chosenCharacteristics.toString()
					: undefined,
				area: this.area.chosenAreas.length
					? this.area.chosenAreas.toString()
					: undefined,
				house: this.houseNumber ? this.houseNumber : undefined
			}

			this.$router.replace({ query: { ...queryObject } }).catch(() => {})
		},
		QueryToState() {
			const querys = this.$route.query
			this.startDate = querys.s ? querys.s : this.startDate
			this.endDate = querys.e ? querys.e : this.endDate
			this.campaignCode.value = querys.cc ? querys.cc : this.campaignCode.value
			this.numberOfPersons.amountAdults = parseInt(querys.a)
				? parseInt(querys.a)
				: this.numberOfPersons.amountAdults
			this.numberOfPersons.amountChildren = parseInt(querys.c)
				? parseInt(querys.c)
				: this.numberOfPersons.amountChildren
			this.numberOfPersons.amountYouths = parseInt(querys.y)
				? parseInt(querys.y)
				: this.numberOfPersons.amountYouths
			this.characteristics.chosenCharacteristics = querys.filter
				? querys.filter.split(',')
				: this.characteristics.chosenCharacteristics
			this.area.chosenAreas = querys.area
				? querys.area.split(',')
				: this.area.chosenAreas
			this.houseNumber = querys.house ? querys.house : this.houseNumber
		},
		handleChange(e) {
			if (e.target.checked) {
				this.activeTab = 3
			} else {
				this.activeTab = 2
			}
		},
		showAccommodationListByArea(areaId) {
			const accByArea = this.allAccommodations.filter(
				each => each.parentpool == areaId
			)
			return accByArea
		},
		scrollAndFocus() {
			window.scrollTo(0, 0)
			this.date.show = true
		},
		totalPeople() {
			return (
				parseInt(this.numberOfPersons.amountAdults) +
				parseInt(this.numberOfPersons.amountYouths) +
				parseInt(this.numberOfPersons.amountChildren)
			)
		}
	},
	computed: {
		detectMandatoryFilters() {
			if (this.houseNumber != '') {
				return true
			} else if (
				this.selectedStartDate != null &&
				this.selectedEndDate != null &&
				(this.numberOfPersons.amountAdults > 0 ||
					this.numberOfPersons.amountSeniors > 0)
			) {
				return true
			} else {
				return false
			}
		},
		apiFilters() {
			return store.state.accommodation.apiFilters
		},
		sortedAccommodationList() {
			//store.dispatch('SET_ACCOMMODATION_RANDOM_LIST_ORDER', [])
			const listCopy = [...this.allAccommodations]
			if (this.currentSortIndex == 1) {
				//Sortera efter pris
				listCopy.sort((a, b) => {
					return a.price - b.price
				})
			} else if (this.currentSortIndex == 2) {
				//Sortera efter avstånd till lift
				listCopy.sort((a, b) => {
					return a.utilities.lift - b.utilities.lift
				})
			} else if (this.currentSortIndex == 3) {
				//Sortera efter stugtitel
				listCopy.sort((a, b) => {
					return a.title.localeCompare(b.title)
				})
			} else if (this.currentSortIndex == 0) {
				//Sortera efter random ordning

				//No saved random order
				if (store.state.accommodation.accRandomListOrder.length == 0) {
					//Randomize area list
					for (let i = this.allAccommodations.length - 1; i > 0; i--) {
						let j = Math.floor(Math.random() * (i + 1))
						let k = listCopy[i]
						listCopy[i] = listCopy[j]
						listCopy[j] = k
					}

					//Store IDs of randomized list
					const accIdList = listCopy.map(function (obj) {
						return obj.id
					})
					store.dispatch('SET_ACCOMMODATION_RANDOM_LIST_ORDER', accIdList)

					//Saved sort order
				} else {
					//Sort acc list according to stored random sort order
					listCopy.sort(function (a, b) {
						return (
							store.state.accommodation.accRandomListOrder.indexOf(a['id']) -
							store.state.accommodation.accRandomListOrder.indexOf(b['id'])
						)
					})
				}
			}

			return listCopy.slice(0, this.currentNumberOfAcc)
		}
	},
	created() {
		this.pageLoading = true
		this.loadingStart = true

		// if (
		// 	this.apiFilters.bookableDates.length &&
		// 	this.apiFilters.cabinAreas.length &&
		// 	this.apiFilters.facilities.length
		// ) {
		// 	this.pageLoading = false
		// 	this.allowedStartDates = this.apiFilters.bookableDates.map(
		// 		item => item.date
		// 	)
		// } else {
		// 	store.dispatch('GET_FILTERS').then(data => {
		// 		this.allowedStartDates = data.bookableDates.map(item => item.date)
		// 		this.pageLoading = false
		// 	})
		// }
		store.dispatch('GET_FILTERS').then(data => {
			this.allowedStartDates = data.bookableDates.map(item => item.date)
			this.pageLoading = false

			this.accommodationHeading = data.textResources[0].title
			this.accommodationBodytext = data.textResources[0].body
			this.accommodationPreamble = data.textResources[0].preamble
			this.campingHeading = data.textResources[1].title
			this.campingBodytext = data.textResources[1].body
			this.accountHeading = data.textResources[2].title
			this.accountHeading = data.textResources[2].preamble
			this.accountBodytext = data.textResources[2].body
			this.calendarAlertText = data.textResources[3].body
		})

		// store.dispatch('GET_AREAS_RANDOM_LIST_ORDER').then(data => {
		// 	this.areasRandomListOrder = data
		// })

		//this.areasRandomListOrder = store.state.accommodation.areasRandomListOrder

		this.QueryToState()
		this.getAccomodation(false)
		//this.getAreasList()

		this.date.accordionLabel = this.$t('search.dateAccordionLabel')
		this.numberOfPersons.accordionLabel = this.$t('search.peopleAccordionLabel')
		this.area.accordionLabel = this.$t('search.areaAccordionLabel')
		this.characteristics.accordionLabel = this.$t(
			'search.characteristicsAccordionLabel'
		)
	}
}
</script>

<style scoped lang="scss">
.input__container {
	background: transparent;
}
.load-overlay {
	position: absolute;
	z-index: 1000;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(127, 139, 161, 0.5);
	width: 100vw;
	padding: 0 20px;
	box-sizing: border-box;
}

.datepicker-alert {
	margin-top: 10px;
}

.full-width {
	width: 100%;
}
.booking-options {
	background: $radial-gradient;

	@include for-tablet-portrait-up {
		background: transparent;
	}
}
.googlemaps {
	height: 400px;
	margin-bottom: 60px;

	@include for-tablet-landscape-up {
		height: 600px;
	}
}

.search {
	@include for-phone-only {
		> .grid-x.grid-margin-x {
			background: #f4f5f7;
			padding-top: 60px;
		}
	}

	> * {
		margin-top: $spacing4;

		&:first-child {
			margin-top: 0;
		}

		@include for-tablet-portrait-up {
			&:first-child {
				margin-top: $spacing7;
			}
		}
	}

	.filters {
		transition: opacity 0.2s ease-in-out;
		&--fade {
			opacity: 50% !important;
		}
		@include for-phone-only {
			box-shadow: 0 0px 8px rgb(129 128 128 / 10%);
			margin-left: -2rem;
			margin-right: -2rem;
			padding: 0 20px 40px 20px;
			margin-top: 0;
			z-index: 5;
			position: relative;
			.accordion__body-inner {
				padding: 0;
			}
		}
	}

	@media print, screen and (min-width: 64em) {
		.filters {
			margin: 0 -20px;
		}

		.grid-x.filters > .large-6 {
			width: calc(50% - 40px);
			margin: 0 20px;
		}
	}

	.search-submit {
		padding: 0;
		box-sizing: border-box;
		@include for-tablet-portrait-up {
			padding: $spacing4;
		}
	}

	.checkbox-list {
		padding-bottom: 20px;
		padding-left: 32px;
		column-count: 1;
		color: #4a4a4a;
		font-size: 16px;
		line-height: 18px;

		div {
			margin: 5px 0;
			display: inline-block;
			width: 100%;
		}

		@include for-tablet-portrait-up {
			column-count: 2;
		}
		@include for-tablet-portrait-up {
			padding-left: 0;
		}
	}

	@include for-tablet-portrait-up {
		.search-submit > button {
			//max-width: 540px;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}
	}
}

.accommodation-search {
	&--loading {
		overflow: hidden;
		&:after {
			content: '';
			width: 100%;
			height: 100%;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.3);
			z-index: 100;
		}
	}
	@include for-phone-only {
		padding: 0px;
	}
	h1 {
		font-family: Saira;
		font-size: 28px;
		color: #434449;
		line-height: 1.4;
		font-weight: 400;
		margin-bottom: 15px;
	}
}

.accommodation-results__byarea {
	padding-top: 40px;
}

.accommodation-results__tabs {
	height: 40px;
	margin: 20px 0 10px 0;

	.tab {
		display: inline;
		padding: 0 10px 4px;
		margin: 0 8px 0 0;
		font-size: 18px;
		line-height: 28px;
		font-weight: 500;

		&--active {
			font-weight: 600;
		}
	}

	@include for-tablet-landscape-up {
		margin: 0 0 20px 0;

		.tab {
			padding: 0 15px 4px 15px;
			margin: 0 20px 0 0;
		}
	}
}

// .accommodation-results__tab-list {
// 	margin-top: 40px;
// }
// .accommodation-results__tab-map {
// 	margin-top: 20px;
// }

.accommodation-results__updating {
	background: #fff;
	box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.1);
	padding: 40px 20px 35px;
	margin-top: 0px;
	text-align: center;
	width: calc(100% - 80px);
	max-width: 560px;
	margin-left: auto;
	margin-right: auto;
	box-sizing: border-box;

	&-heading {
		display: inline-block;
		font-size: 22px;
		line-height: 1.2;
		color: #434449;
		margin: 25px 0 15px;
		max-width: 360px;
	}
	&-text {
		display: inline-block;
		font-size: 14px;
		line-height: 1.7;
		color: #4a4a4a;
		max-width: 360px;
	}

	@include for-tablet-portrait-up {
		margin-top: 60px;
		width: calc(100% - 120px);
	}
	@include for-tablet-landscape-up {
		margin-top: 70px;
	}
	@include for-desktop-up {
		padding: 70px 20px 60px;
		&-heading {
			margin: 25px 0 20px;
		}
	}
}

@media only screen and (min-width: 1220px) {
	.accommodation-results__tab-grid {
		margin-left: -17px;
		margin-right: -17px;
	}
}

.search-housenumber,
.search-housenumber-mobile {
	display: none;
	@include for-tablet-portrait-up {
		display: flex;
		justify-content: flex-end;
	}
	&__input {
		width: 100%;
	}

	&__btn {
		margin-left: 10px;
		padding: 0;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		svg {
			fill: white;
			width: 25px;
			height: 25px;
		}
	}
}
.search-housenumber-mobile {
	width: 100%;
	padding: 10px 0 30px 0;
	display: flex;
	justify-content: flex-end;
	@include for-tablet-portrait-up {
		display: none;
	}
}

.accommodation-results {
	position: relative;
	transition: opacity 0.2s ease-in-out;
	&__sort-buttons {
		display: none;
	}
	&__sort-title {
		color: #434449;
		font-size: 28px;
		letter-spacing: 0;
		line-height: 32px;

		+ .accommodation-results__sort-buttons {
			margin-top: 15px;
		}

		@include for-tablet-portrait-up {
			+ .accommodation-results__sort-buttons {
				margin-top: 0;
			}
		}
	}
	// &--loading {
	// 	opacity: 20%;
	// }
	&__sort-select {
		//background-color: #3e5071;
		// flex-grow: 1;
		/*select {
			height: 50px;
		}*/

		@include for-tablet-portrait-up {
			margin-right: 40px;
		}
	}
	&__sort-buttons {
		display: flex;
		//justify-content: flex-end;
		justify-content: right;
	}
	&__tab-grid {
		// @include for-tablet-portrait-up {
		// 	margin-top: 30px;
		// }
	}
	&__sort {
		background-color: $colorGrey1;
		padding: 20px 0;
		margin-top: 0;
		position: relative;
		@include for-tablet-portrait-up {
			padding: 10px;
			padding-top: 60px;
		}
		/*padding: 10px 8px;
    align-items: center;
    margin-left: -8px;
    margin-right: -8px;
    margin: 35px -8px 0 -8px;*/
	}
	&__sort-desktop {
		display: none;
	}
	&__sort-mobile {
		display: flex;
		align-items: center;
		margin-right: 0;
		margin-left: 20px;
	}
	@include for-tablet-portrait-up {
		padding-top: 50px;
		margin-bottom: 40px;

		&__sort-select {
			background-color: transparent;
		}
		&__sort {
			background-color: transparent;
			padding: 60px 0 0 0;
			position: relative;
			height: auto;
			top: unset;
			left: unset;
			right: unset;
		}
		&__sort-mobile {
			display: none;
		}
		&__sort-desktop {
			display: block;
		}
	}

	&__show-more {
		padding: 40px 15px;
		box-sizing: border-box;
		span {
			margin-top: 20px;
			display: block;
			text-align: center;
		}
	}

	&__no-results {
		margin-top: 60px;

		p {
			margin-top: 19px;
		}

		button {
			margin-top: 30px;
		}
	}
}
.search-tabs {
	display: flex;
	.tab--button {
		text-align: center;
		background: #e9ebef;
		width: 100%;
		padding: 16px 0;
		display: block;
		height: auto;
		z-index: 10;
		appearance: initial;
		-webkit-appearance: initial;
		&.tab--active {
			box-shadow: 0 -6px 8px rgb(129 128 128 / 10%);
			background: #fff;
		}
		&:first-child {
			margin-right: 10px;
		}
		&:last-child {
			margin-left: 10px;
		}
	}
	@include for-tablet-portrait-up {
		display: none;
	}
}

.filter-switch {
	&__checkbox {
		display: none;
		+ .filter-switch__container {
			svg:first-child {
				display: block;
			}
			svg:last-child {
				display: none;
			}
		}
		&:checked + .filter-switch__container {
			svg:first-child {
				display: none;
			}
			svg:last-child {
				display: block;
			}
		}
	}
	svg {
		height: 24px;
		width: 24px;
		fill: $colorSecondary9;
	}
}

.checkbox {
	display: flex;
	position: relative;
	align-items: center;
	width: 100%;
	cursor: pointer;
	&--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
	&__input {
		position: absolute;
		visibility: hidden;
		/*&:checked ~ .input__icon:after {
      transform: scale(1);
    }*/
		+ span > span {
			display: none;
		}
		&:checked {
			+ span {
				background-color: $colorPrimary7;
			}
			+ span > span {
				display: block;
			}
		}
	}
	&__box {
		display: inline-block;
		width: 18px;
		height: 18px;
		box-sizing: border-box;
		border: 1px solid $colorPrimary3;
		box-shadow: inset 0 1px 3px 0 rgba(148, 158, 177, 0.1);
		background-color: $colorWhite;
		border-radius: 3px;
		transition: all 0.3s ease;
		margin-right: 12px;
		position: relative;
		flex-basis: 18px;
		flex-grow: 0;
		flex-shrink: 0;
		svg {
			width: 12px;
			height: 12px;
		}
		> span {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&__title {
		align-items: center;
		display: flex;
		color: $colorPrimary;
		font-size: 16px;
		line-height: 18px;
		text-transform: capitalize;
	}
}

.input-collection .medium-8 {
	@include for-tablet-portrait-up {
		margin-bottom: $spacing4;
	}
}
.input-collection {
	padding-left: 32px;
	@include for-tablet-portrait-up {
		padding-left: 0;
	}
	p.h4 {
		margin-bottom: 0;
		font-size: 22px;
		color: #434449;

		@include for-tablet-portrait-up {
			font-size: 20px;
			color: $colorPrimary;
		}
	}
}
.input-collection p.small {
	font-size: 13px;
}

.formtext.select {
	color: red;
}
</style>
